import React from "react";
import { Navigate } from "react-router";
import BackManagementRouter from "@/views/BackManagement/router.js";
import PortalRouter from "@/views/Portal/router.js";

const routers = [
    ...BackManagementRouter,
    ...PortalRouter,
    {
        path: "*",
        key: "not-found",
        element: <Navigate to="/global/index" replace />,
    }
];
export default routers;
